import { ca } from '@cian/analytics';

export function trackShowPhone(customPageURL: string, action: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action,
    label: customPageURL,
    useLastProducts: true,
  });
}

export function trackOpenContacts(customPageURL: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Reviews',
    action: 'open_contacts',
    label: customPageURL,
    useLastProducts: true,
  });
}
